import {MenuOutlined as AntdMenuOutlined} from '@ant-design/icons';

export default function PlayMenuOutlinedCircleFilled(props) {
  return <AntdMenuOutlined {...props} />;
}
